var exports = {
  "kL": "container__90S1aJ",
  "uI": "subHeader__vlSEU9",
  "B2": "tree__bw3Ztl",
  "Vg": "grid__OBhx4W",
  "$y": "hasDescription__CCOEOD",
  "AS": "item__IVa1tD",
  "q7": "rootItem__psHjFc",
  "jH": "spacer__KNZiNe",
  "pW": "leadingVisual__frDDWR",
  "Qs": "content__WMliHc",
  "DD": "title__PBpGPe",
  "h_": "description__JfVzwZ",
  "zx": "tokenContainer__NHS61E",
  "yJ": "blockedBy__522TGA",
  "LX": "trailingVisual__oBW--s",
  "U5": "rootItemHasSubIssues__uk_s7j",
};

module.exports = exports;
